import { User } from '@project44/ui-utils';

import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { UserCreationFormTemplate } from '../../../domain/forms/templates/UserCreationFormTemplate';
import { IUserCreationForm } from '../../../domain/interfaces';
import { UserDomainSchemas } from '../../../index';

export class UserCreationForm extends UIFormClient<IUserCreationForm> {
  public readonly validationSchema = UserDomainSchemas.userCreationSchema;

  public properties: UIFormClient<IUserCreationForm>['properties'];

  constructor(
    private readonly userCreationFormTemplate: UserCreationFormTemplate,
    private readonly userPrincipal: User,
  ) {
    super();
    this.properties =
      userCreationFormTemplate.compose(userPrincipal).properties;
  }

  public static readonly compose = (
    userCreationFormTemplate: UserCreationFormTemplate,
    userPrincipal: User,
  ): UIFormClient<IUserCreationForm> => {
    return new UserCreationForm(userCreationFormTemplate, userPrincipal);
  };
}
